import checkPWAMethods from '~/utils/checkPWAMethods';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const isPWA = useState('isPWA');
  isPWA.value = checkPWAMethods();

  nextTick(() => {
    if (window) {
      const localStorageKey = 'iOSPWAInstallerOpener';
      const savedValue = localStorage.getItem(localStorageKey);

      if (savedValue !== 'true' && !isPWA.value) {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          useState('iOSPWAInstallerOpener').value = true;
        }
      }
    }
  });
});
